/** A member photo is required for Going, organising and joining meet-ups, and for the perks card. */
export function hasMemberPhoto(avatarUrl: string | null | undefined): boolean {
  return !!avatarUrl?.trim();
}

export function isPhotoRequiredError(error: { message?: string } | null | undefined): boolean {
  return !!error?.message?.includes("PHOTO_REQUIRED");
}
